import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutoFocusEmp]',
})
export class AutoFocusEmperorFormDirective implements AfterContentInit {
  // In some cases, the browser is scrolling so the focused element is off the
  // screen. Adding the preventScroll option helps to keep the focused element
  // visible. This may only be safe when the focused element is above the fold
  @Input({ transform: coerceBooleanProperty }) preventScroll = false;
  constructor(private el: ElementRef) {}

  ngAfterContentInit() {
    setTimeout(() => {
      this.el.nativeElement
        ?.querySelector('input')
        ?.focus({ preventScroll: this.preventScroll });
    }, 500);
  }
}
